module.exports = "<em *ngIf=\"isChecked\" (click)=\"unselect()\" class=\"fa fa-check-square-o checkbox-icon\" [ngClass]=\"{ 'checkbox-disabled': checkboxDisabled }\"></em>\n<em *ngIf=\"!isChecked\" (click)=\"select()\" class=\"fa fa-square-o checkbox-icon\" [ngClass]=\"{ 'checkbox-disabled': checkboxDisabled }\"></em>\n\n<ng-content></ng-content>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/checkbox/checkbox.component.html
// module id = ../../../../../src/app/shared/components/checkbox/checkbox.component.html
// module chunks = main